// extracted by mini-css-extract-plugin
export default {"container":"Vtjm6W"};